export const WIDTH_PROGRESSBAR = 176;
